import { render, staticRenderFns } from "./GalleryListItem.vue?vue&type=template&id=08dddc8e&"
import script from "./GalleryListItem.vue?vue&type=script&lang=js&"
export * from "./GalleryListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports